interface TooltipWrapperProps {
  children: React.ReactNode;
  className?: string;
  variant?: "default" | "bottomTip";
}

export const TooltipWrapper = ({
  children,
  className,
  variant = "default",
}: TooltipWrapperProps) => {
  const showBottomTip = variant === "bottomTip";

  return (
    <div className={`absolute z-[60] text-xl font-[500] sm:text-lg ${className}`}>
      {showBottomTip ? (
        <div className="relative h-[68px] w-[173px]">
          <svg
            className="absolute inset-0 h-full w-full"
            viewBox="0 0 173 68"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <mask id="tooltip-bottom-tip-border-mask" fill="white">
              <path d="M86.7939 67.5L79 54H8C3.58172 54 0 50.4183 0 46V8C0 3.58172 3.58172 0 8 0H165C169.418 0 173 3.58172 173 8V46C173 50.4183 169.418 54 165 54H94.5889L86.7939 67.5Z" />
            </mask>
            <path
              d="M86.7939 67.5L79 54H8C3.58172 54 0 50.4183 0 46V8C0 3.58172 3.58172 0 8 0H165C169.418 0 173 3.58172 173 8V46C173 50.4183 169.418 54 165 54H94.5889L86.7939 67.5Z"
              fill="rgba(0, 0, 0, 0.75)"
            />
            <path
              d="M86.7939 67.5L85.9279 68L86.7939 69.5L87.66 68L86.7939 67.5ZM79 54L79.866 53.5L79.5774 53H79V54ZM0 46H-1H0ZM173 8H174H173ZM94.5889 54V53H94.0115L93.7229 53.5L94.5889 54ZM86.7939 67.5L87.66 67L79.866 53.5L79 54L78.134 54.5L85.9279 68L86.7939 67.5ZM79 54V53H8V54V55H79V54ZM8 54V53C4.13401 53 1 49.866 1 46H0H-1C-1 50.9706 3.02944 55 8 55V54ZM0 46H1V8H0H-1V46H0ZM0 8H1C1 4.13401 4.13401 1 8 1V0V-1C3.02944 -1 -1 3.02944 -1 8H0ZM8 0V1H165V0V-1H8V0ZM165 0V1C168.866 1 172 4.13401 172 8H173H174C174 3.02944 169.971 -1 165 -1V0ZM173 8H172V46H173H174V8H173ZM173 46H172C172 49.866 168.866 53 165 53V54V55C169.971 55 174 50.9706 174 46H173ZM165 54V53H94.5889V54V55H165V54ZM94.5889 54L93.7229 53.5L85.9279 67L86.7939 67.5L87.66 68L95.4549 54.5L94.5889 54Z"
              fill="rgba(255, 255, 255, 0.2)"
              mask="url(#tooltip-bottom-tip-border-mask)"
            />
          </svg>
          <div className="absolute inset-x-0 top-0 flex h-[54px] items-center justify-center px-5">
            <p className="text-center text-white">{children}</p>
          </div>
        </div>
      ) : (
        <div className="relative flex-shrink-0 w-fit px-5 py-4 bg-black/75 backdrop-blur-sm rounded-lg border border-white/20">
          <p className="text-white">{children}</p>
        </div>
      )}
    </div>
  );
};